import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router';
import Container from '../../components/container/Container';
import Input from '../../components/questionnaire/Input';
import db from '../../util/database';
import Tables from '../../util/tables';
import Question from '../../types/Question';
import Client from '../../types/Client';
import Routes, { getQuestionnaire, isChooseQuestionnaireSuccess } from '../../util/routes';
import { Link } from 'react-router-dom';
import { useGetClientFromUrl } from '../../util/hook';

function LeftPanel(props: { client: Client }) {
  return (
    <>
      <h3>Choix du questionnaire</h3>
      <p className="mb-4">Choisissez le questionnaire pour votre client</p>
      <div className="dbox w-100 d-flex align-items-center">
          <div className="icon d-flex align-items-center justify-content-center">
            <span className="fa fa-user" />
          </div>
          <div className="text pl-3">
            <p>{props.client && <>({props.client.idclient}) {props.client.nom} {props.client.prenom}</>}</p>
          </div>
      </div>
    </>
  );
}

const getQuestionnaires = async () => {
  const questions: Question[] = await db().collection(Tables.QUESTIONS).get();
  console.log('[questionnaires] questions:', questions ? questions.length : 'undefined');
  const questionnaires = questions ? questions.reduce((accumulator: any, currentValue: Question) => {
    if (!accumulator[currentValue.nom]) {
      return { ...accumulator, [currentValue.nom]: true };
    }
    return accumulator;
  }, {}) : [];
  return Object.keys(questionnaires);
};

function ChooseQuestionnaire() {
  const { clientId } = useParams<{ clientId: string, success: string }>();
  const [questionnaires, setQuestionnaires] = useState<string[]>([]);
  const history = useHistory();
  useEffect(
    () => {
      const processQuestionnaires = async () => {
        const questionnaires = await getQuestionnaires();
        console.log('[choosequestionnaire] questionnaires:', questionnaires);
        setQuestionnaires(questionnaires);
      }
      processQuestionnaires();
    },
    [clientId],
  );
  const { client, error } = useGetClientFromUrl();
  const onSelectQuestionnaire = (questionaire: string) => () => {
    history.push(getQuestionnaire(clientId, questionaire));
  }
  return (
    <Container title="Visio" leftPanelComponent={<LeftPanel client={client} />}>
      <div className="contact-wrap w-100 p-md-5 p-4">
        <h3 className="mb-4">Choix du questionaire</h3>
        {isChooseQuestionnaireSuccess() && <div id="form-message-success" style={{ display: 'block' }} className="mb-4">
          Votre formulaire a bien été enregistré!
        </div>}
        {error && <>
          <div id="form-message-warning" style={{ display: 'block' }} className="mb-4">{error}</div>
          <Link to={Routes.CHOOSE_CLIENT}>Choisir un client</Link>
        </>}
        {!error && (
          <div className="row">
            {questionnaires.map((questionnaire, index) => (
              <Input key={index} label={questionnaire} type="radio" name="choose-questionnaire" onChange={onSelectQuestionnaire(questionnaire)} /> 
            ))}
          </div>
        )}
      </div>
    </Container>
  );
}

export default ChooseQuestionnaire;
